import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function logReducer(
    state: any = initialState.logs,
    action: { type: string; logs: any }
) {
    switch (action.type) {
        case types.LOAD_LOGS_SUCCESS: {
            return action.logs;
        }
        default:
            return state;
    }
}
